import {LinkProps} from '@tanstack/react-router'

/**
 * Has the following structure:
 *
 * ```
 * {
 *    [pathname]: [searchString] | undefined
 * }
 * ```
 */
type PersisentSearchState = Partial<Record<string, string>>

const LOCAL_STORAGE_KEY = 'cypro_search_state'

export const persistentSearchStateRoutes = new Set<LinkProps['to']>([
  '/patient-dashboard/patients',
  '/configuration/pharmacies',
  '/configuration/customers',
  '/configuration/locations',
  '/configuration/sections',
  '/configuration/wards',
  '/configuration/user-groups',
  '/configuration/users',
  '/configuration/protocols',
  '/configuration/products/companies',
  '/configuration/products/consumables',
  '/configuration/products/trade-names',
  '/configuration/basic-data/$resource',
  '/configuration/basic-data/categories',
  '/reports',
  '/configuration/drug-catalog/active-substances',
  '/configuration/drug-catalog/solutions',
  '/configuration/drug-catalog/supportive-medications',
  '/stocks/batches',
  '/stocks/discards',
  '/stocks/rest-vials',
  '/stocks/returns',
])

export function saveSearchState(pathname: string, search: string) {
  try {
    const prevFilters = getSearchState()
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({...prevFilters, [pathname]: search}))
  } catch (err) {
    console.error(err)
  }
}

export function resetSearchState() {
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({}))
}

/**
 * Parses the whole saved search state returns it.
 * @returns
 */
export function getSearchState(): PersisentSearchState {
  try {
    const filters = localStorage.getItem(LOCAL_STORAGE_KEY)
    if (!filters) return {}
    return JSON.parse(filters)
  } catch (err) {
    console.error(err)
    return {}
  }
}

/**
 * Parses the saved search state and returns the desired key (pathname).
 * @param pathname The pathname for which you want the last saved search.
 */
export function getSearchStateForPathname(pathname: string): string {
  const state = getSearchState()
  return state[pathname] || ''
}
